module.exports = __webpack_public_path__ + "img/Group 947.7f285e1c.png";